// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerNoApiParameter,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { createShipTo, updateShipTo as updateShipToApi } from "@insite/client-framework/Services/CustomersService";
import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import { AddOrUpdateShipTo, chain } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { addDropShipAddress } from "@rc/App/Services/checkoutServices";

export type UpdateShipToParams = {
    billToId: string;
    shipTo: ShipToModel;
    isEdit: boolean;
    canAddToDropShip?: boolean;
} & HasOnSuccess<boolean>;

type HandlerType = ApiHandlerNoApiParameter<UpdateShipToParams, ShipToModel>;

export const XngAddOrUpdateShipTo: HandlerType = async props => {
    if (props.parameter.shipTo.isNew && props.parameter.canAddToDropShip) {
        const params = {
            address: {
                ...props.parameter.shipTo,
                isVmiLocation: !!props.parameter.shipTo?.isVmiLocation,
                isDefault: !!props.parameter.shipTo?.isDefault,

            },
        };
        await addDropShipAddress(params);
    }
    if (props.parameter.shipTo.isNew) {
        props.apiResult = await createShipTo({
            shipTo: {
                ...props.parameter.shipTo,
                isVmiLocation: !!props.parameter.shipTo?.isVmiLocation,
                isDefault: !!props.parameter.shipTo?.isDefault,
                properties: {
                    ...props.parameter.shipTo.properties,
                },
            },
        });
    } else if (props.parameter.isEdit) {
        props.apiResult = await updateShipToApi({
            billToId: props.parameter.billToId,
            shipTo: props.parameter.shipTo,
        });
    } else {
        props.apiResult = await updateShipToApi({
            billToId: props.parameter.billToId,
            shipTo: props.parameter.shipTo,
        });
    }

    // reload to make sure we get validation
    await makeHandlerChainAwaitable(loadShipTo)({
        billToId: props.parameter.billToId,
        shipToId: props.apiResult.id,
    })(props.dispatch, props.getState);
};

replaceInChain(chain, AddOrUpdateShipTo, XngAddOrUpdateShipTo);
